/* src/connects/diary-actions.js */

import { connect } from 'react-redux'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { translate } from 'react-i18next'
import ui from '../helpers/ui-state'

export const mapDispatchToProps = (dispatch)=> {
  return {
    
  }
}

export default combineHOC(
  connect(undefined, mapDispatchToProps),
  ui({ 
    state: { 
      disableLike: false,
      /* アプリで使用するui.state */
      openReaction: false, 
      openCommentReaction: false,
      openReplyReaction: false,
      isTouch: false, 
      selectImage: undefined,
      currentImageFocus: undefined,
      currentImageRelease: undefined, 
      isLongTouch: false,
      fieldHeight: 0,
      /* webで使用するui.state */
      reactionFocus: false, 
      timer: false, 
      innerWidth: 0,
    }
  }),
  lifecycle,
  translate(),
)


// WEBPACK FOOTER //
// ./src/connects/diary-actions.js